import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "../../console/api";
import { refreshAdminToken, rememberedOnThisDevice } from "../../admin/adminSession";

/* Verifies the stored token actually belongs to an admin (role check via
   /auth/me) so staff/manager tokens or stale tokens can't open admin pages
   through direct URLs. A remembered login (httpOnly cookie) can restore a
   missing/expired token silently. */
export default function RequireAdmin({ children }) {
  const token = typeof window !== "undefined" ? localStorage.getItem("heritage-admin-token") : null;
  const [status, setStatus] = useState(token || rememberedOnThisDevice() ? "checking" : "denied");

  useEffect(() => {
    if (!token && !rememberedOnThisDevice()) return undefined;
    let alive = true;
    const check = async () => {
      try {
        if (!token) {
          const fresh = await refreshAdminToken();
          if (!fresh) throw new Error("no session");
        }
        const r = await api.get("/auth/me");
        if (alive) setStatus(r.data?.role === "admin" ? "ok" : "denied");
      } catch {
        if (alive) { localStorage.removeItem("heritage-admin-token"); setStatus("denied"); }
      }
    };
    check();
    return () => { alive = false; };
  }, [token]);

  if (status === "denied") return <Navigate to="/admin/login" replace />;
  if (status === "checking") return null;
  return children;
}
